__turbopack_context__.v({
  "button": "GJalwa_button",
  "buttonAccent": "GJalwa_buttonAccent",
  "container": "GJalwa_container",
});
